import "./Modal.css";

import { createPortal } from 'react-dom';
import { useEffect, useRef, useContext } from 'react';
import ModalContext from "../store/ModalContext";


export default function Modal({ children, open, className = '' }) {
    const dialog = useRef();
    const modalCtx = useContext(ModalContext);

    useEffect(() => {
        const modal = dialog.current;
        if (modalCtx.status) {
            modal.showModal();
        }

        return () => modal.close();

        
    }, [modalCtx.status])


    return createPortal(
        <dialog ref={dialog} className={`modal ${className}`}>
            {children}

        </dialog>, document.getElementById('modal')
    );
}